<span 
    *ngIf="computedValue"
    class="text-{{computedValue > 0 ? 'success' : 'danger'}}"
>
    {{getAbsoluteValue(computedValue)}}% <i class="fa-solid fa-caret-{{computedValue > 0 ? 'up' : 'down'}}"></i>
</span>